import { render, staticRenderFns } from "./SidebarInboxItem.vue?vue&type=template&id=5c531f17&"
import script from "./SidebarInboxItem.vue?vue&type=script&lang=js&"
export * from "./SidebarInboxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports